import { memo } from 'react';
// @mui
import { Box } from '@mui/material';

//
import { StyledRootScrollbar } from './styles';
import { type ScrollbarProps } from './types';

// ----------------------------------------------------------------------

function Scrollbar({ children, sx, ...other }: ScrollbarProps) {
  const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  if (isMobile) {
    return (
      <Box sx={{ overflowX: 'auto', ...sx }} {...other}>
        {children}
      </Box>
    );
  }

  return <StyledRootScrollbar sx={sx}>{children}</StyledRootScrollbar>;
}

export default memo(Scrollbar);
